import { Component, Input } from '@angular/core';
import { ProvidersService, FCCONFIG } from 'fccore2';
import { FcComponent } from '../fc';

import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'fccore2';
import {CacheService} from 'fccore2';

/**
 * fc-printå¾æ 
 * 
 * è¯­ä¹åçç¢éå¾å½¢ã
 * 
 * æä»¬ä¸ºæ¯ä¸ªå¾æ èµäºäºè¯­ä¹åçå½åï¼å½åè§åå¦ä¸:
 * 
 * å®å¿åæçº¿å¾æ ä¿æååï¼ç¨-oæ¥åºåï¼æ¯å¦Â question-circleï¼å®å¿ï¼åÂ question-circle-oï¼æçº¿ï¼ã
 * 
 * å½åé¡ºåºï¼[å¾æ å]-[å½¢ç¶?]-[æçº¿?]-[æ¹å?]ã
 * 
 */
@Component({
    selector: 'fc-adprint',
    template: `
     
        <fc-modalcard [fcTitle]="fcTitle" [fcToken]="token" [fcFooter]="null">
        <fc-layoutpanel fccontent style="height:500px;">
            <fc-title [fcLabel]="fcTitle" fcheader></fc-title>
            <iframe fccontent style="width:100%;height:500px;" [src]="monitor"></iframe>
            </fc-layoutpanel>
        <fc-button [fcLabel]="fcLabel"  [fcIcon]="fcIcon" fcopen ></fc-button>
    </fc-modalcard>
    `,
    styles: [`
    .fc-icon-small{
        font-size:18px;
    }
    .fc-icon-default{
        font-size:22px;
    }
    .fc-icon-large{
        font-size:30px;
    }

    `]
})
export class FcadprintComponent extends FcComponent {
    monitor: SafeResourceUrl;
    token:string = CommonService.guid();
    /** æç¤ºæ é¢*/
    fcTitle:string;
    @Input()
    fcLabel:string;
    @Input()
    fcParam:any;
    _param:string;
    /** iconå¾æ */
    @Input()
    fcIcon: string;
    @Input()
    fcReportlet: string;
    constructor(public provider: ProvidersService,
        public sanitizer: DomSanitizer, ) {
        super(provider, 'fc-adprint'); 
        //="http://pcorp.cn:8082/ReportServer?reportlet=/eam/in.cpt&amp;labornum=ADMIN&amp;id=623&amp;matreqnum=20171017002";
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        let userInfo = CacheService.getS("userinfo");
        if(!this.fcParam){
            this.fcParam = {};
        }
        if(this.fcReportlet){
            this.fcParam["reportlet"]=this.fcReportlet;
        }
        this.fcParam.USERID = userInfo.USERCODE;
        this._param ="?";
        Object.keys(this.fcParam).forEach(key => {
            this._param+= key +"=" + this.fcParam[key]+"&"
        }); 
        this.monitor = this.sanitizer.bypassSecurityTrustResourceUrl(FCCONFIG.reporturl+this._param);
    }
}
